// The hydration verdict stays an agents port: it is `!!useUser().data`, and
// this package may not import `@heidi/workspace/data`. The overlay token-sync
// read lives on `@heidi/auth/state` and is not a member here.

import { injected } from './injected-auth';

/** Has the signed-in identity finished hydrating (`!!useUser().data` app-side). */
export const useIsIdentityHydrated = (): boolean => injected('useIsIdentityHydrated')();
